import 'iframe-resizer/js/iframeResizer.contentWindow';

import { Outlet } from 'react-router';

const PageLayout = () => <Outlet />;

export default PageLayout;
